<template>
  <div class="comparison-page">
    <div class="scroll-wrapper">
      <b-card
        class="comparison-surface"
        style="border:none !important; box-shadow: none !important; outline: none !important;"
      >
        <div class="scroll">
          <div
            :class="{
              'card-container': !hasComparisonData,
              'card-container-after': hasComparisonData,
            }"
            :style="{
              justifyContent:
                selectedCompetitor.length > 2 ? 'start' : 'center',
            }"
          >
            <div class="product-comparison">
              <div class="comparison-table">
                <div
                  class="product-headers"
                  style="margin-bottom:20px !important"
                >
                  <div
                    v-if="hasComparisonData"
                    class="product-header product-header-empty-box"
                  ></div>
                  <div
                    class="product-header"
                    style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);width:50px"
                  >
                    <b-card class="custom-card" @click="openModal('telkom')">
                      <div
                        :class="{
                          'dashed-border': selectedCategory === '',
                          'no-border': selectedCategory !== '',
                        }"
                      >
                        <b-card-text class="b-card-text">
                          <b-img :src="telkomImg" class="img-logo" />
                          <hr v-if="selectedCategory !== ''" />
                          <b-img
                            v-if="selectedCategory === ''"
                            :src="plusIcon"
                            class="icon-plus"
                          />
                          <h3
                            v-else
                            class="selected-category"
                            style="color:#000; font-weight: normal"
                          >
                            <b>{{ selectedCategory }}</b>
                          </h3>
                          <p
                            v-if="selectedCategory === ''"
                            style="margin-top:10px"
                            class="card-text"
                          >
                            Choose Product
                          </p>
                        </b-card-text>
                      </div>
                    </b-card>
                  </div>
                  <div
                    class="product-header"
                    style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px"
                  >
                    <b-card
                      :class="{
                        'custom-card disabled-card': selectedCategory === '',
                        'custom-card': selectedCategory !== '',
                      }"
                      @click="openModal('competitor', 0)"
                    >
                      <div
                        :class="{
                          'dashed-border': selectedCompetitor[0] === undefined,
                          'no-border': selectedCompetitor[0] !== undefined,
                        }"
                      >
                        <b-card-text class="b-card-text">
                          <b-img class="img-logo" />
                          <b-img
                            v-if="selectedCompetitor[0] !== undefined"
                            :src="xIcon"
                            style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                            alt="Remove Competitor"
                            @click.stop="removeCompetitor(0)"
                          />
                          <b-img
                            v-if="disabledIcon === true"
                            :src="plusDisabledIcon"
                            style="width: 45px;margin-top: 34px"
                          />
                          <b-img
                            v-else-if="
                              disabledIcon === false &&
                                selectedCompetitor[0] === undefined
                            "
                            :src="plusDis"
                            style="width: 45px;margin-top: 25px"
                          />
                          <b-img
                            v-else="
                              disabledIcon === false &&
                                selectedCompetitor[0] !== undefined
                            "
                            style="margin-top:35px"
                            :src="
                              getCompetitorImage(
                                competitorData[0].competitorName.key
                              )
                            "
                            class="selected-category img-logo-competitor"
                            alt="Selected Competitor"
                          />
                          <p
                            v-if="selectedCompetitor[0] == undefined"
                            style="margin-top:10px"
                          >
                            Choose Competitor
                          </p>
                        </b-card-text>
                      </div>
                    </b-card>
                  </div>
                  <div
                    v-for="(competitor, index) in competitorData.slice(1)"
                    :key="index"
                    class="product-header"
                    style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px"
                  >
                    <b-card
                      class="custom-card"
                      @click="openModal('competitor', index + 1)"
                    >
                      <div
                        v-if="selectedCompetitor[index] !== undefined"
                        :class="{
                          'dashed-border': !selectedCompetitor[index],
                          'no-border': selectedCompetitor[index],
                        }"
                      >
                        <b-card-text class="b-card-text">
                          <b-img class="img-logo" />
                          <b-img
                            v-if="selectedCompetitor[index]"
                            :src="xIcon"
                            alt="Remove Competitor"
                            class="icon-x"
                            style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                            @click.stop="removeCompetitor(index + 1)"
                          />
                          <b-img
                            v-else
                            :src="plusDis"
                            style="width: 45px;margin-top: 34px"
                          />
                          <b-img
                            v-if="competitor && competitor.competitorName"
                            style="margin-top:35px"
                            :src="
                              getCompetitorImage(competitor.competitorName.key)
                            "
                            class="selected-category img-logo-competitor"
                            alt="Selected Competitor"
                          />
                          <p
                            v-if="!selectedCompetitor[index]"
                            style="margin-top:10px"
                          >
                            Choose Competitor
                          </p>
                        </b-card-text>
                      </div>
                    </b-card>
                  </div>
                  <div
                    v-if="showAddCompetitorCard"
                    class="product-header"
                    style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px"
                  >
                    <b-card
                      class="custom-card"
                      @click="
                        openModal('competitor', selectedCompetitor.length)
                      "
                    >
                      <div class="dashed-border">
                        <b-card-text class="b-card-text">
                          <b-img
                            :src="plusDis"
                            style="width: 45px;margin-top: 34px"
                          />
                          <p style="margin-top:10px">Choose Competitor</p>
                        </b-card-text>
                      </div>
                    </b-card>
                  </div>
                </div>
                <br />

                <!-- Key Differentiator panel, not part of D2P rundown, disabled for now -->
                <!--
                <div v-if="hasComparisonData" class="key-differentiator-panel">
                  <div class="key-differentiator-title">
                    <feather-icon size="18" icon="AwardIcon" />
                    <span>Key Differentiator</span>
                  </div>
                  <p
                    v-if="telkomAdvantages.length > 0"
                    class="key-differentiator-subtitle"
                  >
                    Keunggulan Telkom yang paling menonjol untuk kategori ini.
                  </p>
                  <p v-else class="key-differentiator-subtitle">
                    Belum ada parameter prioritas dengan data yang cukup untuk
                    menentukan keunggulan.
                  </p>
                  <div
                    v-if="telkomAdvantages.length > 0"
                    class="advantage-list"
                  >
                    <div
                      v-for="advantage in telkomAdvantages"
                      :key="advantage.label"
                      class="advantage-chip"
                    >
                      <feather-icon size="13" icon="CheckCircleIcon" />
                      <span>{{ advantage.label }}</span>
                      <b>{{ advantage.value }}</b>
                    </div>
                  </div>
                </div>
                -->

                <div
                  v-for="row in sortedComparisonRows"
                  v-if="hasComparisonData"
                  :key="`row-${row.rawKey}`"
                  class="comparison-row"
                  :class="{ 'priority-row': isPriorityRow(row.rawKey) }"
                >
                  <div
                    class="label"
                  >
                    <p><b v-html="row.formattedKey"></b></p>
                  </div>
                  <div
                    v-for="(provider, providerName) in comparisonData"
                    :key="`${row.rawKey}-${providerName}`"
                    class="value"
                    :class="{
                      'telkom-advantage-cell': isTelkomAdvantageCell(
                        providerName,
                        row.rawKey
                      ),
                    }"
                  >
                    <div class="value-content">
                      <p
                        :class="{
                          'advantage-text': isTelkomAdvantageCell(
                            providerName,
                            row.rawKey
                          ),
                        }"
                        v-html="formatValue(provider[row.rawKey])"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-row
          v-if="hasComparisonData"
          class="d-flex justify-content-between align-items-start mt-1"
        >
          <b-col class="flex-grow-1">
            <p class="source-bottom">
              <i>© Telkom Competitive Pricing Report 2023</i><br />
              <i
                >© Competitive Intelligence Analysis of ICON+ and Lintasarta
                2023</i
              >
            </p>
          </b-col>
          <b-col class="flex-grow-0">
            <div class="action-button-group">
              <b-button
                class="icon-button"
                variant="primary"
                @click="resetCompare"
              >
                <feather-icon size="18" icon="RepeatIcon" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div>
      <div v-if="!hasComparisonData" class="d-flex justify-content-center mt-3">
        <b-button class="w-25" variant="primary" @click="handleCompare"
          >Compare</b-button
        >
      </div>
    </div>
    <b-modal
      v-model="isModalOpen"
      modal-class="modal-product"
      title="Choose Product"
    >
      <b-form-group>
        <b-form-select
          v-model="selectedOption"
          :options="categoriesProduct"
        ></b-form-select>
      </b-form-group>
      <template #modal-footer>
        <div class="text-center gap-2 w-100">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="isModalOpen = false"
            >Close</b-button
          >
          <b-button variant="primary" @click="selectCategory">OK</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="isModalCompetitor"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      modal-class="modal-competitor"
      title="Choose Competitor"
    >
      <b-col cols="12" sm="12" lg="12">
        <b-form-group>
          <v-select
            v-model="selectedCompetitorOptions"
            multiple
            :options="categoriesCompetitors.filter(cc => !cc.disabled)"
            :close-on-select="false"
            :clearable="true"
          />
        </b-form-group>
      </b-col>
      <b-col
        v-if="
          selectedCompetitorOptions
            ? selectedCompetitorOptions.length > 0
            : false
        "
        cols="12"
        md="12"
        class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
      >
      </b-col>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="isModalCompetitor = false"
            >Close</b-button
          >
          <b-button
            style="background-color:#10375C !important"
            @click="selectedCompetitors"
            >OK</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BImg,
  BCardGroup,
  VBModal,
  BFormSelect,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BContainer,
  BTable,
  BFormTags,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BCardText,
    BImg,
    BCardGroup,
    VBModal,
    BFormSelect,
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BContainer,
    BTable,
    BFormTags,
    vSelect,
  },
  data() {
    return {
      telkomImg: require('@/assets/images/logo_telkom horizontal.png'),
      plusIcon: require('@/assets/images/icons/adds.png'),
      plusDis: require('@/assets/images/icons/plusDis.png'),
      plusDisabledIcon: require('@/assets/images/icons/disabledPluss.png'),
      xIcon: require('@/assets/images/icons/remove.png'),
      disabledIcon: true,
      isModalOpen: false,
      isModalCompetitor: false,
      selectedOption: '',
      selectedCategory: '',
      selectedCompetitorOptions: '',
      selectedCompetitor: [],
      categoriesCompetitors: [],
      categoriesProduct: [],
      competitorData: [],
      currentCardIndex: null,
      comparisonData: {},
      showAddCompetitorCard: false,
    }
  },
  computed: {
    hasComparisonData() {
      return Object.keys(this.comparisonData).length > 0
    },
    sortedComparisonRows() {
      if (!this.hasComparisonData) {
        return []
      }

      const firstProviderKey = Object.keys(this.comparisonData)[0]
      const firstProvider = this.comparisonData[firstProviderKey] || {}

      return Object.keys(firstProvider)
        .map(rawKey => {
          const formattedKey = this.formatKey(rawKey)
          return {
            rawKey,
            formattedKey,
            priority: this.getBusinessPriority(rawKey),
          }
        })
        .filter(row => !this.shouldHideLabel(row.formattedKey))
        .sort((a, b) => {
          if (a.priority === b.priority) {
            return a.formattedKey.localeCompare(b.formattedKey)
          }
          return a.priority - b.priority
        })
    },
    priorityParameterLabels() {
      const priorityRows = this.sortedComparisonRows
        .filter(row => row.priority < 99)
        .slice(0, 5)
        .map(row => row.rawKey)

      if (priorityRows.length >= 5) {
        return priorityRows
      }

      const fallbackRows = this.sortedComparisonRows
        .map(row => row.rawKey)
        .filter(rawKey => !priorityRows.includes(rawKey))
        .slice(0, 5 - priorityRows.length)

      return [...priorityRows, ...fallbackRows]
    },
    bestProviderByLabel() {
      const bestMap = {}
      this.sortedComparisonRows.forEach(row => {
        bestMap[row.rawKey] = this.resolveBestProvider(row.rawKey)
      })
      return bestMap
    },
    comparableRows() {
      return this.sortedComparisonRows
        .map(row => row.rawKey)
        .filter(rawKey => !!this.bestProviderByLabel[rawKey])
    },
    telkomAdvantages() {
      return this.comparableRows
        .filter(rawKey => this.bestProviderByLabel[rawKey] === 'TELKOM')
        .map(rawKey => ({
          label: this.formatKey(rawKey).replace(/<br>/g, ' '),
          value: this.formatValue(this.comparisonData.TELKOM?.[rawKey]).replace(
            /<br>/g,
            ' '
          ),
        }))
        .slice(0, 5)
    },
    comparablePriorityCount() {
      return this.comparableRows.length
    },
    telkomAdvantageCount() {
      return this.comparableRows.filter(
        rawKey => this.bestProviderByLabel[rawKey] === 'TELKOM'
      ).length
    },
    showIncompleteCompetitorState() {
      if (!this.hasComparisonData) {
        return false
      }

      const providers = Object.keys(this.comparisonData)
      if (providers.length === 0) {
        return true
      }

      return providers.some(providerName =>
        this.sortedComparisonRows.some(row =>
          this.isEmptyValue(this.comparisonData[providerName]?.[row.rawKey])
        )
      )
    },
  },
  mounted() {
    Promise.all([this.categories()])
  },
  methods: {
    shouldHideLabel(label) {
      const hiddenLabels = ['label']
      return hiddenLabels.includes(label)
    },
    getBusinessPriority(label) {
      const normalizedLabel = String(label)
        .toLowerCase()
        .replace(/<br>/g, ' ')
        .replace(/\n/g, ' ')
      const priorityRules = [
        {
          rank: 1,
          keywords: [
            'monthly charge',
            'harga',
            'price',
            'tarif',
            'biaya bulanan',
          ],
        },
        {
          rank: 2,
          keywords: [
            'installation fee',
            'biaya instalasi',
            'one time charge',
            'install',
          ],
        },
        { rank: 3, keywords: ['sla', 'service level', 'uptime'] },
        {
          rank: 4,
          keywords: [
            'support',
            'helpdesk',
            'response time',
            'customer service',
          ],
        },
        {
          rank: 5,
          keywords: ['coverage', 'cakupan', 'area layanan', 'jaringan'],
        },
        { rank: 6, keywords: ['delivery time', 'lead time', 'working days'] },
        { rank: 7, keywords: ['minimum contract', 'contract', 'kontrak'] },
        { rank: 8, keywords: ['discount', 'diskon'] },
      ]

      const matched = priorityRules.find(rule =>
        rule.keywords.some(keyword => normalizedLabel.includes(keyword))
      )
      return matched ? matched.rank : 99
    },
    isPriorityRow(rawKey) {
      return this.priorityParameterLabels.includes(rawKey)
    },
    getComparisonDirection(label) {
      const normalizedLabel = String(label)
        .toLowerCase()
        .replace(/\n/g, ' ')
      const lowerBetterKeywords = [
        'price',
        'charge',
        'fee',
        'cost',
        'biaya',
        'delivery',
        'time',
        'hari',
        'day',
        'contract',
        'instal',
      ]
      const higherBetterKeywords = [
        'sla',
        'uptime',
        'support',
        'coverage',
        'discount',
        'availability',
        'bandwidth',
      ]

      if (
        lowerBetterKeywords.some(keyword => normalizedLabel.includes(keyword))
      ) {
        return 'lower'
      }
      if (
        higherBetterKeywords.some(keyword => normalizedLabel.includes(keyword))
      ) {
        return 'higher'
      }
      return 'higher'
    },
    parseComparableNumber(value) {
      if (this.isEmptyValue(value)) {
        return null
      }

      const rawText = String(value).toLowerCase()
      const plainText = rawText
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/[^\d.,\-\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()

      if (/\b(free|gratis|no charge|tanpa biaya)\b/.test(rawText)) {
        return 0
      }

      const unitMultiplier = this.getUnitMultiplier(rawText)
      const matches = plainText.match(/-?\d+(?:[.,]\d+)*/g)

      if (!matches || matches.length === 0) {
        return null
      }

      const numericValues = matches
        .map(rawToken => {
          const token = rawToken.trim()
          const dotCount = (token.match(/\./g) || []).length
          const commaCount = (token.match(/,/g) || []).length
          let normalized = token

          if (dotCount > 1 && commaCount === 0) {
            normalized = token.replace(/\./g, '')
          } else if (commaCount > 1 && dotCount === 0) {
            normalized = token.replace(/,/g, '')
          } else if (commaCount === 1 && dotCount === 0) {
            normalized = token.replace(',', '.')
          } else if (commaCount === 1 && dotCount >= 1) {
            normalized = token.replace(/\./g, '').replace(',', '.')
          }

          const parsed = Number(normalized)
          return Number.isFinite(parsed) ? parsed : null
        })
        .filter(item => item !== null)
        .map(item => item * unitMultiplier)

      if (numericValues.length === 0) {
        return null
      }

      if (numericValues.length > 1) {
        const total = numericValues.reduce((acc, current) => acc + current, 0)
        return total / numericValues.length
      }

      return numericValues[0]
    },
    getUnitMultiplier(rawText) {
      if (/\b(m|mn|mio|million|juta|jt)\b/.test(rawText)) {
        return 1000000
      }
      if (/\b(k|rb|ribu|thousand)\b/.test(rawText)) {
        return 1000
      }
      return 1
    },
    resolveBestProvider(rawKey) {
      const providers = Object.keys(this.comparisonData)
      const direction = this.getComparisonDirection(rawKey)
      let winner = null
      let winnerValue = null

      providers.forEach(providerName => {
        const value = this.parseComparableNumber(
          this.comparisonData[providerName]?.[rawKey]
        )
        if (value === null) {
          return
        }

        if (winnerValue === null) {
          winner = providerName
          winnerValue = value
          return
        }

        const isBetter =
          direction === 'lower' ? value < winnerValue : value > winnerValue
        const isTieWithTelkom =
          value === winnerValue && providerName === 'TELKOM'
        if (isBetter || isTieWithTelkom) {
          winner = providerName
          winnerValue = value
        }
      })

      return winner
    },
    isTelkomAdvantageCell(providerName, rawKey) {
      return (
        providerName === 'TELKOM' &&
        this.bestProviderByLabel[rawKey] === 'TELKOM'
      )
    },
    isEmptyValue(value) {
      if (value === null || value === undefined) {
        return true
      }

      const normalized = String(value)
        .trim()
        .toLowerCase()
      return (
        normalized === '' ||
        normalized === '-' ||
        normalized === 'n/a' ||
        normalized === 'na'
      )
    },
    async categories() {
      return await this.$http
        .get(`${process.env.VUE_APP_API_HELPER_URL}/competitor/category`, {
          params: {},
          withCredentials: true,
          headers: {
            'Client-Device': 'browser',
            Authorization: `${this.token}`,
          },
        })
        .then(response => {
          this.categoriesProduct = response.data
        })
    },
    openModal(card, index = 0) {
      this.currentCardIndex = index
      if (card === 'telkom') {
        this.isModalOpen = true
      } else if (card === 'competitor') {
        this.isModalCompetitor = true
      }
    },
    selectCategory() {
      this.selectedCompetitor = []
      this.competitorData = []
      this.categoriesCompetitors = []
      this.selectedCompetitorOptions = ''
      if (this.selectedCompetitor.length == 0) {
        this.showAddCompetitorCard = false
      }
      if (this.selectedCategory === '') {
        this.selectedCategory = this.selectedOption
        this.disabledIcon = false
        this.$http
          .get(
            `${process.env.VUE_APP_API_HELPER_URL}/competitor/byCategory?category=${this.selectedOption}`,
            {
              params: {},
              withCredentials: true,
              headers: {
                'Client-Device': 'browser',
                Authorization: `${this.token}`,
              },
            }
          )
          .then(response => {
            for (const cc of response.data) {
              this.categoriesCompetitors.push({
                key: cc,
                label: cc,
              })
            }
          })
      } else if (
        this.selectedCategory !== '' &&
        Object.keys(this.comparisonData).length == 0
      ) {
        this.selectedCategory = this.selectedOption
        this.$http
          .get(
            `${process.env.VUE_APP_API_HELPER_URL}/competitor/byCategory?category=${this.selectedOption}`,
            {
              params: {},
              withCredentials: true,
              headers: {
                'Client-Device': 'browser',
                Authorization: `${this.token}`,
              },
            }
          )
          .then(response => {
            for (const cc of response.data) {
              this.categoriesCompetitors.push({
                key: cc,
                label: cc,
              })
            }
          })
      } else if (
        this.selectedCategory !== '' &&
        Object.keys(this.comparisonData).length > 0
      ) {
        this.comparisonData = {}
        this.selectedCompetitor = []
        this.competitorData = []
        this.categoriesCompetitors = []
        this.selectedCompetitorOptions = ''
        this.selectedCategory = this.selectedOption
        this.$http
          .get(
            `${process.env.VUE_APP_API_HELPER_URL}/competitor/byCategory?category=${this.selectedOption}`,
            {
              params: {},
              withCredentials: true,
              headers: {
                'Client-Device': 'browser',
                Authorization: `${this.token}`,
              },
            }
          )
          .then(response => {
            for (const cc of response.data) {
              this.categoriesCompetitors.push({
                key: cc,
                label: cc,
              })
            }
          })
        const requestData = {
          category: this.selectedOption,
          competitor: ['TELKOM'],
        }
        this.$http
          .post(
            `${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison`,
            requestData,
            {
              withCredentials: true,
              headers: {
                'Client-Device': 'browser',
                Authorization: `${this.token}`,
              },
            }
          )
          .then(res => {
            this.comparisonData = res.data
          })
          .catch(error => {
            console.error('Error fetching comparison data:', error)
          })
      }
      this.isModalOpen = false
    },
    formatKey(key) {
      return key.replace(/\n/g, '<br>')
    },
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return String(value).replace(/\n/g, '<br>')
    },
    getCompetitorImage(competitorKey) {
      try {
        return require(`@/assets/images/competitor/${competitorKey}.png`)
      } catch (e) {
        console.error('Gagal memuat gambar:', e)
        return require('@/assets/images/competitor/logo_telkom horizontal.png')
      }
    },
    selectedCompetitors() {
      if (this.selectedCompetitorOptions.length > 0) {
        this.selectedCompetitor = [...this.selectedCompetitorOptions]
        this.selectedCompetitorOptions.forEach(competitor => {
          if (
            !this.competitorData.some(
              data => data.competitorName === competitor
            )
          ) {
            this.competitorData.push({ competitorName: competitor })
            this.selectedCompetitor = [...this.competitorData]
            this.showAddCompetitorCard =
              this.selectedCompetitor.length < this.categoriesCompetitors.length
          }
        })
        this.categoriesCompetitors.forEach(cc => {
          cc.disabled = this.selectedCompetitor.some(
            comp => comp.competitorName.key === cc.key
          )
        })
        this.selectedCompetitorOptions = []
        this.isModalCompetitor = false
        if (Object.keys(this.comparisonData).length > 0) {
          this.handleCompare()
        }
        if (
          this.selectedCompetitor.length < this.categoriesCompetitors.length
        ) {
          this.showAddCompetitorCard = true
        }
      } else {
        this.isModalCompetitor = false
        this.$notifOnClick(
          'Sorry!',
          "To ensure you get the best comparison tailored to your needs, please consider our competitors' options first. Thank you for your attention.",
          'danger',
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {}
        )
      }
    },
    handleCompare() {
      const collectCompetitor = []
      this.selectedCompetitor.forEach(competitor => {
        if (competitor) {
          collectCompetitor.push(competitor.competitorName.key)
        }
      })
      const requestData = {
        category: this.selectedOption,
        competitor: collectCompetitor,
      }
      if (requestData.competitor.length > 0) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison`,
            requestData,
            {
              withCredentials: true,
              headers: {
                'Client-Device': 'browser',
                Authorization: `${this.token}`,
              },
            }
          )
          .then(res => {
            const existingData = this.comparisonData
            const newData = res.data
            collectCompetitor.forEach((item, index) => {
              if (newData[item]) {
                newData[item].label = item
                newData.TELKOM.label = 'TELKOM'
              }
            })
            this.comparisonData = {
              ...existingData,
              ...newData,
            }
          })
          .catch(error => {
            console.error('Error fetching comparison data:', error)
          })
      } else {
        this.$notifOnClick(
          'Sorry!',
          "To ensure you get the best comparison tailored to your needs, please consider our competitors' options first. Thank you for your attention.",
          'danger',
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {}
        )
      }
    },
    resetCompare() {
      this.comparisonData = {}
      this.selectedCategory = ''
      this.selectedOption = ''
      this.selectedCompetitor = []
      this.competitorData = []
      this.categoriesCompetitors = []
      this.disabledIcon = true
      this.currentCardIndex = null
      this.isModalOpen = false
      this.isModalCompetitor = false
      this.showAddCompetitorCard = false
      this.selectedCompetitorOptions = ''
    },

    removeCompetitor(index) {
      const competitorName = this.selectedCompetitor[index]?.competitorName?.key
      this.selectedCompetitor.splice(index, 1)
      this.competitorData.splice(index, 1)
      if (competitorName && this.comparisonData[competitorName]) {
        this.$delete(this.comparisonData, competitorName)
      }
      this.categoriesCompetitors.forEach(cc => {
        cc.disabled = this.selectedCompetitor.some(
          comp => comp?.competitorName?.key === cc.key
        )
      })
      if (
        (Object.keys(this.comparisonData).length == 1 &&
          this.comparisonData.TELKOM) ||
        this.selectedCompetitor.length == 0
      ) {
        this.showAddCompetitorCard = false
      } else if (
        this.selectedCompetitor.length < this.categoriesCompetitors.length
      ) {
        this.showAddCompetitorCard = true
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style scoped>
.comparison-page {
  position: relative;
}

.comparison-surface {
  background: transparent;
}

.comparison-surface ::v-deep .card-body {
  padding: 0.5rem;
}

.scroll-wrapper {
  position: sticky;
  border-radius: 18px;
  background: radial-gradient(
      circle at 10% -25%,
      rgba(217, 35, 45, 0.1),
      transparent 45%
    ),
    radial-gradient(circle at 95% 0%, rgba(16, 55, 92, 0.1), transparent 40%),
    #ffffff;
  border: 1px solid #eceff5;
  box-shadow: 0 16px 42px rgba(18, 28, 45, 0.08);
  overflow: hidden;
  padding: 8px 10px 2px;
}

.scroll {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.card-container {
  display: flex;
  white-space: nowrap;
  overflow: auto;
}

.card-container-after {
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 20px;
}

.custom-card {
  min-width: 250px;
  height: 170px;
  overflow: hidden;
  margin: 0 6px;
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
  border-radius: 14px;
  border: 1px solid #edf0f7;
  box-shadow: 0 8px 24px rgba(26, 38, 65, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.custom-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(26, 38, 65, 0.13);
}

.disabled-card {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.product-comparison {
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
}

.comparison-table {
  display: table;
  width: 100%;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
}

.dashed-border {
  border: 1px dashed #c2cad8;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.b-card-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  text-align: center;
  flex-grow: 1;
}

.img-logo {
  width: 80%;
  max-height: 80px;
  object-fit: contain;
}

.img-logo-competitor {
  width: 130px;
  height: 80px;
  margin: 0 auto;
  justify-content: center;
  object-fit: contain;
  align-items: center;
  text-align: center;
}

.icon-plus {
  width: 45px;
}

.product-headers {
  display: table-row;
  margin-bottom: 20px;
}

.product-header {
  display: table-cell;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
  min-width: 50px;
}

.product-header-empty-box {
  box-shadow: 0 4px 10px rgba(167, 167, 167, 0.06);
  position: sticky;
  left: 0;
  z-index: 9999;
  background-color: #f8fbff;
}

.comparison-row {
  display: table-row;
  border-collapse: separate;
}

.comparison-row > .label,
.comparison-row > .value {
  display: table-cell;
  padding: 12px 10px;
  background-color: #fff;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #e8edf4;
  width: 220px;
  min-width: 220px;
  max-width: 320px;
  white-space: normal;
  word-break: break-word;
}

.label > p {
  min-width: 170px;
  font-weight: bold;
  color: #28364f;
  margin-bottom: 0;
}

.comparison-row > .label:not(:last-child),
.comparison-row > .value:not(:last-child) {
  border-right: none;
}

.comparison-row > .label {
  box-shadow: 6px 0 20px rgba(216, 225, 238, 0.3);
  text-align: left;
  position: sticky;
  left: 0;
  z-index: 140;
  background-color: #f7faff;
}

.priority-row > .label,
.priority-row > .value {
  background: linear-gradient(90deg, #fff9f9 0%, #ffffff 80%);
}

.comparison-row > .value {
  position: relative;
  z-index: 1;
}

.telkom-advantage-cell {
  background: transparent;
}

.value-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.advantage-text {
  color: #000;
  font-weight: normal;
  margin-bottom: 0;
}

.advantage-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #f6c4c7;
  background: #ffe5e7;
  color: #d9232d;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
}

.key-differentiator-panel {
  margin: 8px 0 12px;
  padding: 14px;
  border: 1px solid #f4d7d7;
  border-radius: 14px;
  background: linear-gradient(93deg, #fff5f5 0%, #ffffff 78%);
  box-shadow: 0 8px 20px rgba(217, 35, 45, 0.08);
  animation: fade-up 0.35s ease;
  position: sticky;
  left: 0;
  z-index: 180;
  width: fit-content;
  min-width: 420px;
  max-width: calc(100vw - 64px);
}

.key-differentiator-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d9232d;
  font-weight: 700;
  margin-bottom: 6px;
}

.key-differentiator-subtitle {
  margin: 0;
  color: #5d5f6d;
  font-size: 13px;
}

.advantage-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.insight-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 10px;
  margin: 0 0 12px;
  position: sticky;
  left: 0;
  z-index: 175;
  width: fit-content;
  min-width: 560px;
  max-width: calc(100vw - 64px);
}

.insight-item {
  border-radius: 12px;
  border: 1px solid #e5eaf2;
  background: linear-gradient(160deg, #ffffff 0%, #f9fbff 100%);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  box-shadow: 0 7px 16px rgba(25, 50, 84, 0.06);
}

.insight-item-primary {
  border-color: #f3cdcf;
  background: linear-gradient(150deg, #fff4f5 0%, #fffefe 100%);
}

.insight-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #63708a;
  font-weight: 700;
}

.insight-value {
  font-size: 21px;
  line-height: 1.1;
  color: #1f2f4d;
}

.insight-item-primary .insight-value {
  color: #d9232d;
}

.insight-meta {
  color: #7a889f;
  font-size: 11px;
  font-weight: 600;
}

.advantage-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 6px 10px;
  background: #ffffff;
  border: 1px solid #f2cbce;
  color: #961b23;
  font-size: 12px;
}

.advantage-chip b {
  color: #d9232d;
}

.incomplete-state {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 9px 12px;
  border-radius: 8px;
  background: #fff7e8;
  border: 1px solid #f5e2b5;
  color: #6e5a2f;
  font-size: 13px;
  animation: fade-up 0.35s ease;
  position: sticky;
  left: 0;
  z-index: 176;
  width: fit-content;
  min-width: 420px;
  max-width: calc(100vw - 64px);
}

.vpn-header img {
  max-width: 200px;
  height: auto;
}

.icon-button {
  cursor: pointer;
}

.action-button-group {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.export-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.source-bottom {
  color: grey;
  font-weight: 600;
}

@keyframes fade-up {
  from {
    transform: translateY(8px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .scroll-wrapper {
    border-radius: 12px;
    padding: 6px;
  }

  .comparison-table {
    overflow-x: auto;
  }

  .comparison-row > .label {
    position: unset;
  }

  .product-header-empty-box {
    position: unset;
  }

  .product-header img {
    max-width: 80px;
  }

  .action-button-group {
    flex-wrap: wrap;
  }

  .custom-card {
    min-width: 220px;
    width: 220px;
    margin: 0 4px;
  }

  .comparison-row > .label,
  .comparison-row > .value {
    min-width: 170px;
    width: 170px;
    max-width: 220px;
    padding: 8px;
    font-size: 12px;
  }

  .key-differentiator-panel {
    padding: 10px;
    min-width: 280px;
    max-width: calc(100vw - 28px);
  }

  .incomplete-state {
    min-width: 280px;
    max-width: calc(100vw - 28px);
  }

  .insight-strip {
    grid-template-columns: 1fr;
    min-width: 280px;
    max-width: calc(100vw - 28px);
  }

  .advantage-chip {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
<style>
/* .vs__dropdown-option--selected, */
/* .vs__dropdown-option--highlight, */
/* .vs__dropdown-option:focus, */
/* .vs__dropdown-option:hover {
  background-color: transparent !important;
  color: white !important;
} */

/* .v-select .vs__dropdown-toggle:hover {
  background-color: #10375C;
} */

/* .v-select:hover .vs__dropdown-toggle {
  background-color: transparent !important;
} */

.vs__selected {
  background-color: #10375c !important;
  color: white !important;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}

.vs__dropdown-option--selected {
  background-color: #10375c !important;
  border-color: #10375c !important;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
  color: white !important;
}

.vs__dropdown-option--highlight {
  background-color: #10375c !important;
  color: white !important;
}

.vs__deselect {
  fill: white !important;
}

.vs__dropdown-option:hover {
  background-color: #10375c !important;
  color: white !important;
}

.vs--open .vs__dropdown-toggle {
  border-color: #10375c !important;
  border-bottom-color: #10375c !important;
  color: white !important;
}

.vs--open .vs__dropdown-menu {
  left: 0;
  text-align: left;
  color: white !important;
}
/* .red-text{
  color: red;
  font-weight:600;
} */
/* .b-avatar.badge-light-danger {
  background-color: red;
  color: white
} */
.modal-product .modal-header {
  background-color: #dc3545 !important;
  color: white !important;
}

.modal-competitor .modal-header {
  background-color: #10375c !important;
  color: white !important;
}

.modal-title {
  color: white;
  font-weight: 600;
}
</style>
